import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  ApolloLink,
} from "@apollo/client";
import { createHttpLink } from "@apollo/client";
import { createContentfulSnapshotLink } from "./lib/contentfulSnapshotLink";
const httpLink = createHttpLink({
  uri: "https://graphql.contentful.com/content/v1/spaces/4oc8oz7m0lsf/",
  headers: {
    Authorization: "Bearer hUIeUwSzRFwd58Tcz4iymLBGicccSTbQRw-UYMqI6J0",
  },
});

export const ApClient = new ApolloClient({
  link: ApolloLink.from([createContentfulSnapshotLink(), httpLink]),
  cache: new InMemoryCache(),
  ssrMode: true,
  defaultOptions: {
    watchQuery: {
      variables: { locale: localStorage.getItem("lang") || "it" },
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ApolloProvider client={ApClient}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
);

reportWebVitals();
